import { SVGProps } from "react"

type CheckboxIconProps = SVGProps<SVGSVGElement> & {
  size?: number
}

const CheckboxIcon = ({ size = 24, color, ...props }: CheckboxIconProps) => {
  const innerSize = Math.max(size - 1, 0)

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      {...props}
    >
      <rect
        width={innerSize}
        height={innerSize}
        x={0.5}
        y={0.5}
        fill="#fff"
        stroke={color || "#6F6F6F"}
        rx={3.5}
      />
    </svg>
  )
}

export default CheckboxIcon
